import _ from "lodash";

const getters = {
    getMessages: (state) => {
        return _.orderBy(state.chat, ['created_at'],['asc'])
    }
};
export default getters;